<template>
  <div>
    <!-- Zoom Panel -->
    <div
      id="expandableZoom"
      v-if="collapsedComponent == 'zoom'"
      :class="expand ? 'blue-box-expanded' : 'blue-box-collapsed'"
    >
      <MMP_CollapsedZoom
        :expanded="expand"
        :map="map"
        :zoomLevel="zoomLevel"
        @click="expansionToggle()"
        @zoomLevelChanged="$emit('zoomLevelChanged', $event)"
      ></MMP_CollapsedZoom>
    </div>

    <!-- Coordinates Panel -->
    <div
      id="expandableCoordinates"
      v-if="collapsedComponent == 'coordinates'"
      :class="expand ? 'blue-box-expanded' : 'blue-box-collapsed'"
    >
      <MMP_CollapsedCoordinates
        :coords="coords"
        :expanded="expand"
        :map="map"
        :pointVectorSource="pointVectorSource"
        :ansiComponent="ansiComponent"
        :drtComponents="drtComponents"
        :showToggle="showToggle"
        @addPoint="$emit('addPoint', $event)"
        @showToggle="$emit('showToggle')"
        @click="expansionToggle()"
        @getVectorlayer="$emit('getVectorlayer', $event)"
        @toggleChange="$emit('toggleChange', $event)"
      ></MMP_CollapsedCoordinates>
    </div>

    <!-- Extents Panel -->
    <div
      id="expandableExtents"
      v-if="collapsedComponent == 'extents'"
      :class="expand ? 'blue-box-expanded' : 'blue-box-collapsed'"
    >
      <MMP_CollapsedExtents
        :expanded="expand"
        :map="map"
        :selectedExtent="selectedExtent"
        :userOrg="userOrg"
        :baseMapsOpen="baseMapsOpen"
        @extentsExpandChange="$emit('extentsExpandChange', $event)"
        @click="expansionToggle()"
        @extentChanged="$emit('extentChanged', $event)"
      ></MMP_CollapsedExtents>
    </div>

    <!-- Base Map Panel -->
    <div
      id="expandableBaseMaps"
      ref="parentBox"
      v-if="collapsedComponent == 'base'"
      :class="expand ? 'blue-box-expanded' : 'blue-box-collapsed'"
    >
      <MMP_CollapsedBaseMap
        :parentRef="$refs.parentBox"
        :currentBaseMap="currentBaseMap"
        :expanded="expand"
        :map="map"
        :isAnsiComponent="isAnsiComponent"
        :extentsOpen="extentsOpen"
        :showLidarPanel="showLidarPanel"
        @baseMapsExpandChange="$emit('baseMapsExpandChange', $event)"
        @click="expansionToggle()"
        @toggleBaseLayer="$emit('toggleBaseLayer', $event)"
      ></MMP_CollapsedBaseMap>
    </div>

    <!-- Lidar Toggle Panel -->
    <div
      id="expandableLidarToggle"
      v-if="collapsedComponent == 'lidar'"
      class="blue-box-collapsed"
    >
      <MMP_CollapsedLidarToggle
        :lidarMinZoomAchieved="lidarMinZoomAchieved"
        :showLidarPanel="showLidarPanel"
        @lidarToggleChange="$emit('lidarToggleChange')"
      ></MMP_CollapsedLidarToggle>
    </div>

    <!-- Measuring Tool -->
    <div
      id="expandableMeasureToolToggle"
      v-if="collapsedComponent == 'measure'"
      :class="
        !showMeasuringTool
          ? 'blue-box-collapsed'
          : 'blue-box-collapsed measure-blue-box'
      "
      @click="measureTriggerProp = true"
    >
      <MMP_CollapsedMeasuringTool
        :map="map"
        :measureTriggerProp="measureTriggerProp"
        :showMeasuringTool="showMeasuringTool"
        @resetToggleMeasureProp="measureTriggerProp = false"
        @toggleMeasuringTool="$emit('toggleMeasuringTool')"
      ></MMP_CollapsedMeasuringTool>
    </div>
  </div>
</template>

<style scoped>
/* CSS unrelated to screen width */

.blue-box-collapsed {
  background: #063c6d;
  position: absolute;
  right: 0px;
  width: 110px;
  /* height: 110px; */
  transition: all 0.4s;
  filter: blur(0);
  -webkit-filter: blur(0);
}
.blue-box-expanded {
  background: #063c6d;
  position: absolute;
  right: 0px;
  /* height: 110px; */
  transition: all 0.4s;
  filter: blur(0);
  -webkit-filter: blur(0);
}
.collapsed-text {
  cursor: pointer;
  -webkit-user-select: none; /* Safari */
  -moz-user-select: none; /* Firefox */
  -ms-user-select: none; /* IE10+/Edge */
  user-select: none; /* Standard */
  position: absolute;
  top: 82%;
  right: 54px;
  color: #0496e9;
  font-size: 13px;
  font-family: 'Inter Bold', 'Open sans', sans-serif;
}
.expanded-text {
  cursor: pointer;
  -webkit-user-select: none; /* Safari */
  -moz-user-select: none; /* Firefox */
  -ms-user-select: none; /* IE10+/Edge */
  user-select: none; /* Standard */
  position: absolute;
  top: 82%;
  right: 36px;
  color: #0496e9;
  font-size: 13px;
  font-family: 'Inter Bold', 'Open sans', sans-serif;
}
</style>

<script>
import MMP_CollapsedBaseMap from './MMP_CollapsedBaseMap.vue'
import MMP_CollapsedCoordinates from './MMP_CollapsedCoordinates.vue'
import MMP_CollapsedExtents from './MMP_CollapsedExtents.vue'
import MMP_CollapsedLidarToggle from './MMP_CollapsedLidarToggle.vue'
import MMP_CollapsedZoom from './MMP_CollapsedZoom.vue'
import MMP_CollapsedMeasuringTool from './MMP_CollapsedMeasuringTool.vue'
export default {
  name: 'MMP_ExpandableDisplay',
  components: {
    MMP_CollapsedBaseMap,
    MMP_CollapsedCoordinates,
    MMP_CollapsedExtents,
    MMP_CollapsedLidarToggle,
    MMP_CollapsedZoom,
    MMP_CollapsedMeasuringTool
  },
  props: [
    'ansiComponent',
    'drtComponents',
    'collapsedComponent',
    'currentBaseMap',
    'homeScreenComponents',
    'lidarMinZoomAchieved',
    'map',
    'selectedExtent',
    'showLidarPanel',
    'userOrg',
    'zoomLevel',
    'showMeasuringTool',
    'pointVectorSource',
    'isAnsiComponent',
    'showToggle',
    'extentsOpen',
    'baseMapsOpen',
    'analyticsVisible'
  ],
  data() {
    return {
      expand: false,
      coords: [],
      measureTriggerProp: false,
      snippingTriggerProp: false
    }
  },
  methods: {
    expansionToggle() {
      this.expand = !this.expand
    },
    showCoords(incomingCoords) {
      this.coords = incomingCoords
    }
  }
}
</script>
